import { render, staticRenderFns } from "./TwTradingStatusIcon.vue?vue&type=template&id=1f775367&scoped=true&"
import script from "./TwTradingStatusIcon.vue?vue&type=script&lang=js&"
export * from "./TwTradingStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./TwTradingStatusIcon.vue?vue&type=style&index=0&id=1f775367&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f775367",
  null
  
)

export default component.exports